var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"vid":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input',{attrs:{"hidden":""}}),_c('transition',{attrs:{"name":"fade"}},[(errors[0])?[_c('div',{staticClass:"d-flex align-items-center mb-4"},[_c('icon-info'),_c('span',{staticClass:"error-yellow"},[_vm._v(_vm._s(errors[0]))])],1)]:_vm._e()],2)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }